import { ReactToastifyTypeEnum } from "@enums/reactPackages";
import { ToastContent, ToastOptions, toast } from "react-toastify";
import { ztkMessages } from "zaions-tool-kit";
export const showNotification = (
  content: ToastContent,
  type: ReactToastifyTypeEnum = ReactToastifyTypeEnum.success,
  options?: ToastOptions
): void => {
  toast(content, {
    ...options,
    position: options?.position ?? "top-right",
    type: type,
  });
};

export const showSuccessNotification = (
  message: ToastContent = ztkMessages.general.success,
  options?: ToastOptions
): void => {
  showNotification(message, ReactToastifyTypeEnum.success, options);
};

export const showErrorNotification = (
  message: ToastContent = ztkMessages.general.failed,
  options?: ToastOptions
): void => {
  showNotification(message, ReactToastifyTypeEnum.error, options);
};
